// extracted by mini-css-extract-plugin
module.exports = {"title":"BigText_title__7agei"};